/**
 * Economy types for the Legendary Arena game engine.
 *
 * TurnEconomy tracks per-turn attack/recruit point accumulation and spending.
 * CardStatEntry holds parsed card stat values resolved at setup time.
 *
 * All fields are integers >= 0. The parser enforces this at setup time.
 */
// why: WP-831 / D-24764 — a City larger than five spaces (Change the Outcome of WWII's USSR) has a
// sixth space with no name. Fighting there targets this value, which no restricted-attack grant
// ever names (grants are parsed from printed space names), so only plain Attack can pay for it.
/** The fight target of an unnamed City space (a space beyond the normal five). */
export const UNNAMED_CITY_SPACE_TARGET = 'unnamed-city-space';
//# sourceMappingURL=economy.types.js.map